import {
  convertLimitTemperature,
  convertToTempUnits,
} from '../../../util/convert-temp-units';
import {
  Celsius,
  TemperatureUnit,
} from '../../../../../system/models/temperatureUnits';
import { CurrentAttributes } from '../types/current-attributes';

type AutoTargetState = Partial<
  Pick<
    CurrentAttributes,
    'operatingMode' | 'supportsSingleSetpointAutoMode' | 'setpoint'
  >
>;

export function getAutoTargetUpdates(
  confirmed: AutoTargetState,
  draft: AutoTargetState,
  units: TemperatureUnit,
  allowModeChange = false,
): { setpoint?: number } {
  if (
    !confirmed.supportsSingleSetpointAutoMode ||
    (!allowModeChange && confirmed.operatingMode !== 'Auto') ||
    !draft.supportsSingleSetpointAutoMode ||
    draft.operatingMode !== 'Auto' ||
    draft.setpoint === confirmed.setpoint ||
    typeof draft.setpoint !== 'number' ||
    !Number.isFinite(draft.setpoint)
  )
    return {};
  return {
    setpoint: allowModeChange
      ? convertLimitTemperature(draft.setpoint, Celsius, units)
      : convertToTempUnits(draft.setpoint, Celsius, units, 2),
  };
}

export function nextAutoTarget(
  value: number | null | undefined,
  delta: number,
  min: number | null | undefined,
  max: number | null | undefined,
  units: TemperatureUnit,
) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined;
  const display = Math.min(
    max ?? Infinity,
    Math.max(min ?? -Infinity, value + delta),
  );
  return { display, celsius: convertToTempUnits(display, Celsius, units, 2) };
}
